import { render, staticRenderFns } from "./full_dynamic_table.vue?vue&type=template&id=0c4a6a53&"
import script from "./full_dynamic_table.vue?vue&type=script&lang=ts&"
export * from "./full_dynamic_table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports